import Editable from "../../Editable";
import InfoField from "../../InfoField";
import { useQuery } from "@apollo/client";
import ORGANIZATION from "../../../api/queries/organization";
import UPDATE_ORGANIZATION from "../../../api/mutations/updateOrganization";
// import SPORTS from "../../../api/queries/sports";
import moment from "moment";
import Form from "../../Form";
import { FaTimes } from "react-icons/fa";

import Loading from "../../Loading";
import { Fragment } from "react";

function OrganizationContacts({ id }) {
  const { loading, error, data } = useQuery(ORGANIZATION, {
    variables: { id },
  });

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    // return <div>Loading</div>;
  }

  const organization = data?.organization;

  return (
    <div className="card">
      <div className="card-title">Contact Details</div>
      {loading || !data ? (
        <div className="loading-wrapper">
          <Loading />
        </div>
      ) : (
        <Fragment>
          <div className="card-body">
            {organization.contactMechanisms.map((c) => (
              <Editable
                form={(setEditing) => (
                  <Form
                    className={"editable-field-form"}
                    initialState={{ type: c.type, value: c.value }}
                    fields={[
                      {
                        label: "Type",
                        type: "select",
                        key: "type",
                        items: [
                          { label: "Phone", value: "Phone" },
                          { label: "Email", value: "Email" },
                        ],
                        optionLabel: (i) => i.label,
                      },
                      {
                        label: "Value",
                        type: "text",
                        key: "value",
                      },
                    ]}
                    mutation={UPDATE_ORGANIZATION}
                    update={(cache, { data: { updateOrganization } }) => {
                      const q = cache.readQuery({
                        query: ORGANIZATION,
                        variables: { id },
                      });
                      cache.writeQuery({
                        query: ORGANIZATION,
                        variables: { id },
                        data: {
                          organization: {
                            ...q.organization,
                            contactMechanisms:
                              updateOrganization.contactMechanisms,
                          },
                        },
                      });

                      setEditing(false);
                    }}
                    vars={(s) => ({
                      where: { id },
                      data: {
                        contactMechanisms: {
                          update: {
                            where: { id: c.id },
                            data: {
                              type: s.type,
                              value: s.value,
                            },
                          },
                        },
                      },
                    })}
                    options={[
                      <div
                        className="option cancel"
                        onClick={() => {
                          setEditing(false);
                        }}
                      >
                        <FaTimes />
                      </div>,
                    ]}
                  />
                )}
                content={(setEditing) => (
                  <InfoField
                    setEditing={setEditing}
                    label={c.type + (c.subtype ? " - " + c.subtype : "")}
                    value={c.value}
                    required={false}
                  />
                )}
              />
            ))}
          </div>

          <div className="card-footer">
            <Editable
              form={(setEditing) => (
                <Form
                  className={"editable-field-form"}
                  initialState={{
                    type: "",
                    value: "",
                  }}
                  fields={[
                    {
                      label: "Type",
                      type: "select",
                      key: "type",
                      items: [
                        { label: "Phone", value: "Phone" },
                        { label: "Email", value: "Email" },
                      ],
                      optionLabel: (i) => i.label,
                    },
                    {
                      label: "Value",
                      type: "text",
                      key: "value",
                    },
                  ]}
                  mutation={UPDATE_ORGANIZATION}
                  update={(cache, { data: { updateOrganization } }) => {
                    const q = cache.readQuery({
                      query: ORGANIZATION,
                      variables: { id },
                    });
                    cache.writeQuery({
                      query: ORGANIZATION,
                      variables: { id },
                      data: {
                        organization: {
                          ...q.organization,
                          contactMechanisms:
                            updateOrganization.contactMechanisms,
                        },
                      },
                    });

                    setEditing(false);
                  }}
                  vars={(s) => {
                    return {
                      where: { id },
                      data: {
                        contactMechanisms: {
                          create: {
                            type: s.type,
                            value: s.value,
                          },
                        },
                      },
                    };
                  }}
                  options={[
                    <div
                      className="option cancel"
                      onClick={() => {
                        setEditing(false);
                      }}
                    >
                      <FaTimes />
                    </div>,
                  ]}
                />
              )}
              content={(setEditing) => (
                <div
                  className={"App-btn success hover-pointer "}
                  onClick={() => {
                    setEditing(true);
                  }}
                >
                  Add Contact Info
                </div>
              )}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default OrganizationContacts;
